class Cupom extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.handleCopyCoupon.bind(this));
  }

  handleCopyCoupon() {
    const coupon = this.textContent;
    const temp_text = "Copiado";

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(coupon);

      return this.changeInnerTextTemporarily(temp_text, 1000);
    }

    // Fallback para navegadores antigos
    let textarea = document.createElement("textarea");
    textarea.value = texto;
    textarea.style.position = "fixed"; // Evita rolagem da página

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      let sucesso = document.execCommand("copy");
      console.log(sucesso ? "Texto copiado com sucesso!" : "Falha ao copiar.");
    } catch (err) {
      console.error("Erro ao copiar: ", err);
    }

    document.body.removeChild(textarea);
  }

  changeInnerTextTemporarily(text, time) {
    const originalText = this.textContent;
    this.textContent = text;
    this.classList.add("copied");

    setTimeout(() => {
      this.textContent = originalText;
      this.classList.remove("copied");
    }, time);
  }
}

customElements.define("sku-copy", Cupom);